(() => {
  const preparePanels = (scope) => {
    if (!window.matchMedia('(max-width: 760px)').matches) return;
    scope.querySelectorAll('.ss-catalog-sidebar > .ss-catalog-panel').forEach((panel) => {
      if (panel.dataset.mobilePrepared) return;
      panel.open = false;
      panel.dataset.mobilePrepared = 'true';
    });
  };
  preparePanels(document);
  document.addEventListener('shopify:section:load', (event) => preparePanels(event.target));
})();
